// 주문 리소스
export default {
    delivery_charge: "배달대행료",
};
